var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyCashedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_32)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#DCF3F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_408_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 21,
    width: 28,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3331 21.3334H18.6665V41.3334H45.3331V21.3334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_408_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8332 21.3334H21.1665C19.7888 21.3334 18.6665 22.4557 18.6665 23.8334V38.8334C18.6665 40.2112 19.7888 41.3334 21.1665 41.3334H42.8332C44.211 41.3334 45.3332 40.2112 45.3332 38.8334V23.8334C45.3332 22.4557 44.211 21.3334 42.8332 21.3334ZM20.3332 38.8334V23.8334C20.3332 23.3723 20.7055 23.0001 21.1665 23.0001H27.1222V26.8945L25.7499 25.5223C24.7888 24.5613 23.2166 24.5613 22.2554 25.5223C21.2943 26.4834 21.2943 28.0557 22.2554 29.0168C22.7222 29.4834 23.3443 29.739 23.9999 29.739H25.9443L24.1499 31.5334C23.8222 31.8613 23.8222 32.389 24.1499 32.7112C24.311 32.8723 24.5276 32.9557 24.7387 32.9557C24.9499 32.9557 25.1665 32.8723 25.3276 32.7112L27.1222 30.9168V39.6667H21.1665C20.7055 39.6667 20.3332 39.2945 20.3332 38.8334ZM25.9443 28.0723H23.9999C23.7888 28.0723 23.5832 27.989 23.4332 27.839C23.1222 27.5279 23.1222 27.0168 23.4332 26.7001C23.5832 26.5501 23.7888 26.4667 23.9999 26.4667C24.211 26.4667 24.4166 26.5501 24.5665 26.7001L25.9387 28.0723H25.9443ZM43.6665 38.8334C43.6665 39.2945 43.2943 39.6667 42.8332 39.6667H28.7888V30.9168L30.5832 32.7112C30.7443 32.8723 30.961 32.9557 31.1721 32.9557C31.3832 32.9557 31.5999 32.8723 31.761 32.7112C32.0888 32.3834 32.0888 31.8557 31.761 31.5334L29.9665 29.739H31.911C32.5721 29.739 33.1888 29.4834 33.6554 29.0168C34.1222 28.5501 34.3777 27.9279 34.3777 27.2667C34.3777 26.6056 34.1222 25.989 33.6554 25.5168C32.6943 24.5557 31.1222 24.5557 30.161 25.5168L28.7888 26.889V23.0001H42.8332C43.2943 23.0001 43.6665 23.3723 43.6665 23.8334V38.8334ZM29.9665 28.0723L31.3387 26.7001C31.6499 26.389 32.161 26.389 32.4777 26.7001C32.6276 26.8501 32.711 27.0557 32.711 27.2667C32.711 27.4778 32.6276 27.6834 32.4777 27.8334C32.3276 27.9834 32.1222 28.0667 31.911 28.0667H29.9665V28.0723Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6944 36.1725H34.8443C34.3832 36.1725 34.011 36.5447 34.011 37.0057C34.011 37.4669 34.3832 37.8391 34.8443 37.8391H41.6944C42.1554 37.8391 42.5276 37.4669 42.5276 37.0057C42.5276 36.5447 42.1554 36.1725 41.6944 36.1725Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6944 33.4001H34.1666C33.7055 33.4001 33.3332 33.7723 33.3332 34.2335C33.3332 34.6945 33.7055 35.0667 34.1666 35.0667H41.6944C42.1554 35.0667 42.5276 34.6945 42.5276 34.2335C42.5276 33.7723 42.1554 33.4001 41.6944 33.4001Z",
    fill: "#194142"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyCashedIn);
export default __webpack_public_path__ + "static/media/loyalty_cashed_in.50d476fef63c2ddf0f84f14d21fa5da6.svg";
export { ForwardRef as ReactComponent };